import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import type { ApiToken } from "../settings/settings.interface";

@Injectable({
  providedIn: "root",
})
export class ApiSettingsService {
  private baseUrl = "/api-settings";

  constructor(private http: HttpClient) {}

  getTokens(): Observable<ApiToken[]> {
    return this.http.get<ApiToken[]>(`${this.baseUrl}/tokens`);
  }

  createToken(name: string, expiresIn?: number): Observable<ApiToken> {
    const body: { name: string; expiresIn?: number } = { name };
    if (expiresIn != null && expiresIn > 0) {
      body.expiresIn = expiresIn;
    }
    return this.http.post<ApiToken>(`${this.baseUrl}/tokens`, body);
  }

  deleteToken(tokenId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/tokens/${tokenId}`);
  }

  revokeToken(tokenId: string): Observable<ApiToken> {
    return this.http.post<ApiToken>(
      `${this.baseUrl}/tokens/${tokenId}/revoke`,
      {},
    );
  }
}
